import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PartyCard.css';
import { getPartyById, getPartyGoer } from '../apiCalls/partyAPI';
import AuthContext from '../contexts';
import { CacheContext } from '../contexts';
import { NotificationContext } from '../contexts/NotificationContext';

function PartyCard({ partyId }) {
    const visible = { visibility: 'visible' };
    const hidden = { visibility: 'hidden' };
    const [modalShow, setModalShow] = useState(hidden);
    const { user } = useContext(AuthContext);
    const { cachedParties, setCachedParties, setActiveParty } = useContext(CacheContext);
    const { showToast } = useContext(NotificationContext);
    const [party, setParty] = useState(null);
    const [host, setHost] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        cachedParties.map(party => {
            if (party.id === partyId) {
                setParty(party);
            }
        });

        if (!party) {
            setModalShow(visible);
            getPartyById(partyId, user.credential)
                .then(party => {
                    setParty(party);
                    setCachedParties([...cachedParties, party]);
                })
                .finally(() => setModalShow(hidden))
                .catch(error => {
                    if (!error.response) {
                        showToast('Unable to reach server. Please try again.', 'error');
                    } else {
                        showToast('Failed to load party. Please try again.', 'error');
                    }
                });
        }
    }, [partyId]);

    useEffect(() => {
        if (party) {
            setModalShow(visible);
            getPartyGoer(party.adminEmail, user.credential)
                .then(partyGoer => {
                    setHost(partyGoer);
                })
                .finally(() => setModalShow(hidden))
                .catch(error => {
                    if (!error.response) {
                        showToast('Unable to reach server. Please try again.', 'error');
                    } else {
                        showToast('Failed to load host info. Please try again.', 'error');
                    }
                });
        }
    }, [party]);

    return (
        <div className="card text-dark party-card">
            <span className="loader" style={modalShow}></span>
            <div className="card-body">
                <h1 className="card-title">{party?.partyName} {party?.oscarYear}</h1>
                <h3 className="card-title">Hosted By: {host?.firstName} {host?.lastName}</h3>
                <button className="btn btn-primary" onClick={() => { setActiveParty(party); navigate(`/party/view/${partyId}`); }}>Go To Party!</button>
            </div>
        </div>
    );
}

PartyCard.propTypes = {
    partyId: PropTypes.string.isRequired
};

export default PartyCard;
